import styled, {ThemeProps} from 'styled-components';

import {Theme} from '../../../../../theme/types';
import getRatingsColor from '../../../../../../shared/utils/getRatingsColor';
import Image from '../../../common/Image/Image';

export const AutocompleteWrapperStyles = styled.div(
  (props: ThemeProps<Theme>) => `
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`,
);

export const SearchInputStyles = styled.input(
  (props: ThemeProps<Theme>) => `
    width:100%;
    border:none;
    font-size: ${props.theme.font.large.font30};
    font-weight: ${props.theme.font.fontWeight.black};
    color: ${props.theme.colors.black.base};
    text-transform: capitalize;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &::placeholder {
      overflow: visible;
      color: ${props.theme.colors.grey.base1};
      font-size: ${props.theme.font.large.font30};
      font-family: ${props.theme.font.fontFamily};
      font-weight: ${props.theme.font.fontWeight.black};
    }
    &:focus {
      box-shadow: none;
      outline-offset: 0;
      outline: 0;
    }
`,
);

export const SearchListItem = styled.li(
  (props: ThemeProps<Theme>) => `
  display: flex;
  align-items: center;
  height: 62px;
  border-top: 1px solid ${props.theme.colors.grey.grey15};
  padding: ${props.theme.spacing.nospacing} ${props.theme.spacing.large.l16};;
  font-size: ${props.theme.font.large.font16};
  background: ${
    // @ts-ignore
    props.isActive ? props.theme.colors.grey.grey15 : props.theme.colors.white.base
  }
  &:first-child{
    border-top:none;
  }
`,
);

export const SearchMenuStyles = styled.ul`
  z-index: ${props => props.theme.misc.zIndex.xxlarge};
  position: absolute;
  top: ${props => props.top || '4rem'};
  left: ${props => props.left || '-2rem'};
  /* left: ${props => -props.theme.spacing.large.l20}; */
  list-style-type: none;
  background: ${props => props.theme.colors.white.base};
  border-radius: 4px;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.16);
  transform: translateY(4px);
  min-width: 54rem; /** zepline has 746px, change to it if need*/
  max-height: ${props => (props.maxHeight ? props.maxHeight : '90vh')};
  overflow-y: auto;
  ${SearchListItem} :first-of-type {
    border-top: none;
  }
`;

export const SearchHotelNumber = styled.p(
  props => `
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  color:${props.theme.colors.grey.grey50};
  font-size:${props.theme.font.large.font14};
  font-weight:normal;
  margin-top:${props.theme.spacing.small.s5};
  `,
);

export const SearchListItemLocationName = styled.span`
  flex: 3;
  /* font-weight: bold; */
`;

export const SearchListItemLocationType = styled.div`
  flex: 1;
  text-align: right;
  font-weight: bold;
  text-transform: capitalize;

  /* these are needed so that <Text /> span inside rating div takes full height of its parent ( the div )*/
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const ErrorMessage = styled.div(
  (props: ThemeProps<Theme>) => `
  color: ${props.theme.colors.red.base};
  font-size: ${props.theme.font.large.font14};
  padding: ${props.theme.spacing.small.s2};
  font-weight:normal;
  position: absolute;
  right: 0;
`,
);

export const StyledIcon = styled.div(
  (props: ThemeProps<Theme>) => `
  height: 2.4rem;
  fill:${props.theme.colors.grey.grey50};
  width: 2.4rem;
  margin: 0 ${props.theme.spacing.large.l13} 0 0;
`,
);

export const SearchLabelStyles = styled.label(
  (props: ThemeProps<Theme>) => `
  color: ${props.theme.colors.white.base};
  padding-bottom: ${props.theme.spacing.small.s5};
  padding-left: ${props.theme.spacing.small.s2};
`,
);

export const RatingStyles = styled.span(props => {
  return `
  color: ${props.theme.colors.white.base};
  background: ${getRatingsColor(props.rating)};
  border-radius: 2px;
  padding: ${props.theme.spacing.small.s3} ${props.theme.spacing.small.s5};

  display: flex;
  width: fit-content;
`;
});

export const TripadvisorImageStyles = styled(Image)`
  max-width: 3rem;
  padding-right: 0.4rem;
`;
